import script from "./ChangeAccountModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeAccountModal.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./ChangeAccountModal.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__